import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import {
  canViewAdminDashboardGivings,
  canViewGivingInAdmin,
  canViewNonProfitGiving,
  canViewProfitGiving,
} from '../permissions';

export const useGivingsPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canViewAdminDashboardGivings: bindViewer(canViewAdminDashboardGivings),
      canViewGivingInAdmin: bindViewer(canViewGivingInAdmin),
      canViewNonProfitGiving: bindViewer(canViewNonProfitGiving),
      canViewProfitGiving: bindViewer(canViewProfitGiving),
    }),
    [bindViewer],
  );
};
